import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {
  API_CREATE_SALES,
  API_DELETE_SALES,
  API_GET_SALES_LIST,
  API_UPDATE_SALES,
} from "../../../shared/routes/private.routes";

const config = {
  name: "sales",
};

export const getSalesList: any = createAsyncThunk(
  `${config.name}/getSalesList`,
  async ({ params, body }: any) => {
    return Client.post(API_GET_SALES_LIST, body, { params });
  }
);

export const createSales: any = createAsyncThunk(
  `${config.name}/createSales`,
  async (body: any) => {
    return Client.post(API_CREATE_SALES, body);
  }
);

export const updateSalesById: any = createAsyncThunk(
  `${config.name}/updateSales`,
  async ({ salesId, body }: { salesId: string; body: any }) => {
    return Client.put(API_UPDATE_SALES + salesId, body);
  }
);

export const deleteSalesById: any = createAsyncThunk(
  `${config.name}/deleteSales`,
  async (salesId: string) => {
    return Client.delete(API_DELETE_SALES + salesId);
  }
);

export const salesReducer = createSlice({
  name: config.name,
  initialState: {
    loadingSales: false as any,
    salesList: [] as any,
    pagination: { page: 0, limit: TABLE_ROWS_COUNT, total: 0 },
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getSalesList.pending, (state) => {
        state.loadingSales = true;
        state.salesList = [];
      })
      .addCase(getSalesList.fulfilled, (state, action) => {
        state.loadingSales = false;
        state.salesList = action?.payload?.data?.data || [];
        state.pagination = {
          page: action?.payload?.data?.page,
          limit: action?.payload?.data?.limit,
          total: action?.payload?.data?.total,
        };
      })
      .addCase(getSalesList.rejected, (state) => {
        state.loadingSales = false;
        state.salesList = [];
      });
  },
});

export default salesReducer.reducer;
